import { Switch } from "antd";
import { ProductKind, ProductTypeT, ShrinkageProduct } from "constants/chart.constants";
import styled from "styled-components";
import { getProductTooltip } from "utils";
import { getProductIcon } from "utils/chart/getProductIcon";
import { getShortenedProductName } from "utils/chart/productNameHelpers";

import { Tooltip } from "components/base";
import { getProductLabel } from "components/charts/utils/getProductLabel";

import ProductHeader from "../../ProductHeader";
import { ProductButton } from "../ProductSelector.styles";

export const ShrinkagePercentageProductHeader = ({
  selectedProductGroup,
  yieldsType,
  rawLabel,
  salesLabel,
  onChangeType,
  setProduct,
  product,
  inletRateLabel,
  outletRateLabel,
  entityKind
}) => {
  if (selectedProductGroup !== ProductKind.Shrinkage) {
    return null;
  }
  const index = yieldsType === rawLabel ? 1 : 2;
  const header: ProductTypeT = ShrinkageProduct[index];

  return (
    <>
      <ButtonContainer>
        <Switch
          unCheckedChildren={rawLabel}
          checkedChildren={salesLabel}
          checked={yieldsType === salesLabel}
          onChange={onChangeType}
          size="small"></Switch>
      </ButtonContainer>

      <ProductHeader key={header.name} header={header.name}>
        {header.items.map((prod) => (
          <Tooltip key={prod} title={getProductTooltip(prod, selectedProductGroup)}>
            <ProductButton
              key={prod}
              onClick={() => {
                setProduct(prod);
              }}
              className={`${prod === product ? "isSelected" : null}`}>
              {getProductIcon(prod)}
              <span>
                {getShortenedProductName(
                  getProductLabel(prod, entityKind),
                  rawLabel,
                  salesLabel,
                  inletRateLabel,
                  outletRateLabel
                )}
              </span>
            </ProductButton>
          </Tooltip>
        ))}
      </ProductHeader>
    </>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  transform: translate(-10px, 30px);
  margin-top: -16px;
  position: relative;
  z-index: 1;

  .ant-switch {
    background-color: var(--color-primary);
  }
`;
